// App.js
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { useLocation } from 'react-router-dom';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const NavigationScroll = ({ children }) => {
    const location = useLocation();
    const { pathname } = location;

    useEffect(() => {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: isMobile ? 'auto' : 'smooth'
        });

        // More graceful overscroll behavior
        if (isMobile) {
            document.body.style.overscrollBehaviorY = 'contain';
        }

        return () => {
            document.body.style.overscrollBehaviorY = '';
        };
    }, [pathname]);

    return children;
};

const App = () => {
    const customization = useSelector((state) => state.customization);

    useEffect(() => {
        // Safe DOM-related changes after mount
        if ('ontouchstart' in document.documentElement) {
            document.body.style.overscrollBehavior = 'none';
            document.addEventListener(
                'touchmove',
                (e) => {
                    if (e.target.closest('.ps') || e.target.closest('.ps__rail-x') || e.target.closest('.ps__rail-y')) {
                        e.stopPropagation();
                    }
                },
                { passive: true }
            );
        }

        if (isMobile && 'serviceWorker' in navigator) {
            const lastUpdate = localStorage.getItem('lastSwUpdate');
            const now = Date.now();
            if (!lastUpdate || now - parseInt(lastUpdate) > 10 * 60 * 1000) {
                navigator.serviceWorker.getRegistrations().then((registrations) => {
                    for (let registration of registrations) {
                        registration.update();
                    }
                });
                localStorage.setItem('lastSwUpdate', now.toString());
            }
        }
    }, []);

    useEffect(() => {
        // Suppress findDOMNode deprecation warnings in development
        if (process.env.NODE_ENV !== 'production') {
            const originalConsoleError = console.error;
            console.error = (...args) => {
                if (args[0] && typeof args[0] === 'string' && args[0].includes('findDOMNode')) {
                    return;
                }
                originalConsoleError(...args);
            };
        }
    }, []);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <NavigationScroll>
                    <Routes />
                </NavigationScroll>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
